import { Button } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Conditional } from '@resurs/react-utils'
import { getText } from '../../../../internal/TextLabels'
import {
  fetchInvoicePdf as fetchInvoicePdfAction,
  resendInvoice as resendInvoiceAction,
} from '../../../../store/actions/transactions-actions'
import PrintModalUI from '../../../PayApply/pages/shared/PrintModalUI'
import ResendInvoiceModal from './ResendInvoiceModal'
import styles from './styles.module.scss'

class InvoiceInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = { pdfUrl: null, showResendModal: false }
  }

  render() {
    const { value, payment, entry, fetchInvoice, resendInvoice } = this.props
    return (
      <>
        <Conditional when={!!this.state.pdfUrl}>
          {() => (
            <PrintModalUI
              url={this.state.pdfUrl}
              show={!!this.state.pdfUrl}
              closeText={getText('default.close')}
              onClose={() => this.setState({ pdfUrl: null })}
            />
          )}
        </Conditional>
        <Conditional when={!!this.state.showResendModal}>
          {() => (
            <ResendInvoiceModal
              show
              email={payment.customer.email || ''}
              onClose={() => this.setState({ showResendModal: false })}
              resendInvoice={email =>
                resendInvoice(payment.id, entry.invoiceData.pdfId, email)
              }
            />
          )}
        </Conditional>
        <table className={styles.invoiceTable}>
          <tbody>
            <tr>
              <td>{value}</td>
              <Conditional
                when={
                  !!entry.invoiceData &&
                  !!entry.invoiceData.pdfId &&
                  !!entry.invoiceData.documentName
                }
              >
                <td className={styles.buttonContainer}>
                  <Button
                    icon="midasFileDownload"
                    onClick={() =>
                      fetchInvoice(
                        entry.invoiceData.pdfId,
                        entry.invoiceData.documentName,
                      ).then(url => url && this.setState({ pdfUrl: url }))
                    }
                    type="link"
                  >
                    {getText('transactions.transaction.history.print')}
                  </Button>
                  <Button
                    icon="midasMailSent1"
                    onClick={() => this.setState({ showResendModal: true })}
                    type="link"
                  >
                    {getText('transactions.transaction.history.resend')}
                  </Button>
                </td>
              </Conditional>
              <Conditional
                when={
                  !entry.invoiceData ||
                  (!!entry.invoiceData &&
                    !entry.invoiceData.pdfId &&
                    !entry.invoiceData.documentName)
                }
              >
                <td className={styles.noInvoice}>
                  {getText('transactions.transaction.history.noInvoiceCreated')}
                </td>
              </Conditional>
            </tr>
          </tbody>
        </table>
      </>
    )
  }
}

InvoiceInfo.propTypes = {
  value: PropTypes.string.isRequired,
  payment: PropTypes.object.isRequired,
  entry: PropTypes.object.isRequired,
  fetchInvoice: PropTypes.func.isRequired,
  resendInvoice: PropTypes.func.isRequired,
}

export default connect(null, dispatch => ({
  fetchInvoice: (pdfId, documentName) =>
    dispatch(fetchInvoicePdfAction(pdfId, documentName)),
  resendInvoice: (paymentId, pdfId, email) =>
    dispatch(resendInvoiceAction({ paymentId, pdfId, email })),
}))(InvoiceInfo)
